import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OpportunitySnapshotsService } from '../../services/opportunity-snapshots.service';
import { SurplusLinesExistingCoverage, SurplusLinesPlanDesignsRequest } from '../../models/surplus-lines-plan-design.model';

@Component({
  selector: 'app-extended-earnings',
  standalone: false,
  templateUrl: './extended-earnings.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class ExtendedEarningsComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<ExtendedEarningsComponent>);
  EEBDuration: string = '';
  EEBDurationOptions: string[] = [];
  cost: string = '';
  monthlyBenefit: string = '';
  eliminationPeriod: string = '';
  planDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();
  additionalPlanDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();

  constructor(private _oss: OpportunitySnapshotsService) {
  }

  ngOnInit() {
    this.EEBDurationOptions = this.getExtendedEarningsOptions();
    if(this.EEBDuration == ''){
      this.EEBDuration = this._oss.currentQuoteOptions?.EEBDurationDefault as string;
    }
    this.updateCost();
  }

  getExtendedEarningsOptions() {
    if (this._oss.currentQuoteOptions == null) {
      return [];
    }
    return this._oss.currentQuoteOptions.EEBDurationOptions.replaceAll('; ', ';').split(';');
  }

  updateCost() {
    var existingCoverages: SurplusLinesExistingCoverage[] = [];

    this._oss.currentOpportunitySnapshot.OtherInsurance.forEach(element => {
      var existing = new SurplusLinesExistingCoverage();
      existing.Amount = element.MonthlyAmount;
      existing.Type = element.Type;
      existing.Payee = element.Paid;
      existingCoverages.push(existing);
    });

    this.additionalPlanDesignRequest.OpportunityId = this._oss.currentCompassOpportunity?.CompassId as number;
    this.additionalPlanDesignRequest.EarnedIncome = this._oss.currentApplicant.AnnualIncome;
    this.additionalPlanDesignRequest.ExistingCoverages = existingCoverages;
    this.additionalPlanDesignRequest.InsuredId = this._oss.currentCompassOpportunity?.InsuredId as number;
    this.additionalPlanDesignRequest.TTDMonthlyBenefit = this.monthlyBenefit;
    this.additionalPlanDesignRequest.EP = this.eliminationPeriod;
    this.additionalPlanDesignRequest.EEBDuration = this.EEBDuration;
    this.additionalPlanDesignRequest.BenefitDuration = this._oss.currentQuoteOptions?.DurationDefault as string;

    this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.additionalPlanDesignRequest).subscribe(additionalQuote => {
      this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.planDesignRequest).subscribe(originalQuote => {
        this.cost = String(additionalQuote[0].YearOneCost - originalQuote[0].YearOneCost);
      });
    });
  }

  inclusion(){
    if(this._oss.currentQuoteOptions?.EEBInclusion == 'Y'){
      return true;
    }
    return false;
  }

  updateEEB() {
    this.updateCost();
  }

  yes() {
    this.dialogRef.close({EEBDuration: this.EEBDuration, cost: this.cost});
  }

  no() {
    this.dialogRef.close(false);
  }
}
